import React from 'react'
import { Button } from '../../atoms'
import Text from '../../atoms/Text/Text'
import ControlHighlight from '../KeyboardControls/ControlHighlight'
import { useKeyboardControls } from '../../../contexts/KeyboardControlsContext'
import KeyboardControl from '../KeyboardControls/KeyboardControl'
import { HighlightEffect } from '../../../enums/KeyboardControls'
import ProgressiveImage from '../ProgressiveImage/ProgressiveImage'
import orientationIcon from '../../../assets/images/Rotate Tablet Icon 1.png'

export enum FocusableElement {
  ButtonAccept = 'button-continue'
}

interface OrientationWarningModalProps {
  onAccept: () => void
  acceptDisabled?: boolean
}

const OrientationWarningModal: React.FC<OrientationWarningModalProps> = ({ onAccept, acceptDisabled = false }) => {
  const keyboardControls = useKeyboardControls()

  return (
    <div className='flex flex-col items-center justify-center h-full text-center'>
      <h1 className='w-full text-center text-[26px] font-bold text-dopage-lightGreen'>
        Device Orientation
      </h1>

      <div className='flex-1 flex flex-col justify-center items-center max-w-[480px] mx-auto w-full'>
        <div className='mb-8'>
          <ProgressiveImage
            alt='Device orientation icon.'
            loading={false}
            loadingSrc={orientationIcon}
            src={orientationIcon}
            className='h-36 w-36'
          />
        </div>

        <div className='text-center mb-16'>
          <Text
            className='leading-[2rem]'
            size='SM'
            text='Please rotate your device to '
            type='span'
          />
          <Text
            bold
            className='leading-[2rem]'
            size='SM'
            text='landscape orientation'
            type='span'
          />
          <Text
            className='leading-[2rem]'
            size='SM'
            text=', if it is not already, while using the Portal for the smoothest training experience.'
            type='span'
          />
        </div>

        <div className='w-11/12'>
          <ControlHighlight
            active={keyboardControls.isEnabled && keyboardControls.isElementFocused(FocusableElement.ButtonAccept)}
            highlightEffect={HighlightEffect.ButtonHexOutline}
            data-testid={`highlight-${FocusableElement.ButtonAccept}`}
          >
            <KeyboardControl>
              <Button
                className='h-[86px] w-full diamond-btn font-bold flex justify-center items-center'
                data-testid={FocusableElement.ButtonAccept}
                disabled={acceptDisabled}
                loading={acceptDisabled}
                onClick={onAccept}
                id={FocusableElement.ButtonAccept}
                type='submit'
              >
                <Text
                  bold
                  className='text-black'
                  size='LG'
                  text='Accept'
                  type='span'
                />
              </Button>
            </KeyboardControl>
          </ControlHighlight>
        </div>
      </div>
    </div>
  )
}

export default OrientationWarningModal
